module.exports = __webpack_public_path__ + "53c06ef950a7e2321118d9c79a020034.png";